import { parse as c } from "querystring";
import * as e from "ramda";
const n = (t, p) => {
  const r = e.prop(p, t);
  return e.is(Array, r) ? e.prop(0, r) : r;
}, a = e.pipe(
  e.split("?"),
  e.head,
  e.split("#"),
  e.head
), u = (t, p = []) => {
  const s = e.pipe(
    e.split("?"),
    e.propOr("", "1")
  )(t), o = Object.keys(c(s));
  return !e.isEmpty(e.difference(o, p));
};
export {
  u as hasQuery,
  n as queryGetOne,
  a as removeQuery
};
//# sourceMappingURL=index.js.map
